import { Facet, FacetNavigation } from "../Sidebar/Filters";

const getSelectedFiltersByOrder = (
  facetNavigation: FacetNavigation,
  isLeafCategoryPage: boolean,
) => {
  const {
    categoryFacets,
    brandFacets,
    partFacets,
    specificationFacets,
    searchWithinFacet,
  } = facetNavigation;

  const getSelectedFilters = ({ sectionGroups }: Facet) => {
    return sectionGroups?.filter((sectionGroup) => {
      return sectionGroup.groupItems.some((sectionGroupItem) => {
        return sectionGroupItem.isSelected === true;
      });
    });
  };

  const brandFilter = getSelectedFilters(brandFacets);
  const categoryFilter = !isLeafCategoryPage
    ? getSelectedFilters(categoryFacets)
    : [];
  const partsFilter = getSelectedFilters(partFacets);
  const searchWithinFilter = getSelectedFilters(searchWithinFacet);
  const selectedSpecificationFilters = getSelectedFilters(specificationFacets);
  const plusFilter = selectedSpecificationFilters?.filter(
    (group) => group.groupName === "WebstaurantPlus",
  );
  const outletConditionFilter = selectedSpecificationFilters?.filter(
    (group) => group.groupName === "Condition",
  );
  const quickShipFilter = selectedSpecificationFilters?.filter(
    (group) => group.groupName === "Quick Ship",
  );
  const specificationFilters = selectedSpecificationFilters
    ?.filter((group) => group.groupName !== "WebstaurantPlus")
    .filter((group) => group.groupName !== "Condition")
    .filter((group) => group.groupName !== "Quick Ship");

  const orderedList = isLeafCategoryPage
    ? [
        plusFilter,
        quickShipFilter,
        brandFilter,
        specificationFilters,
        partsFilter,
        searchWithinFilter,
      ]
    : [
        categoryFilter,
        plusFilter,
        outletConditionFilter,
        quickShipFilter,
        brandFilter,
        partsFilter,
        specificationFilters,
        searchWithinFilter,
      ];

  return orderedList.filter((x) => x?.length !== 0);
};

export default getSelectedFiltersByOrder;
